import type { Timeseries } from '../../../core/types/timeseries.js';
import type { PointsDisplay, GapPolicy } from '../../types/timeseries-props.js';
import type { TimeseriesChartVisualProps } from '../../types/timeseries.js';

/**
 * Props for the TimeseriesChart.Line slot component
 * @public
 */
export interface TimeseriesChartLineProps extends TimeseriesChartVisualProps {
  /** The series data passed to the line */
  data: Timeseries;
  /** Defines how gaps are handled (connect vs. gap) */
  gapPolicy?: GapPolicy;
  /** Whether to show data points always, never, or depending on a width-based threshold amount */
  pointsDisplay?: PointsDisplay;
}

/**
 * @public
 */
export const Line = (props: TimeseriesChartLineProps) => null;

Line['displayName'] = 'TimeseriesChart.Line';
